import React from "react";
import { Avatar } from "components/Avatar";
import { getStockCompanyIcon } from "utils";
import { ArrowDownLossIcon, ArrowUpProfitIcon, laptop } from "assets/icons";
import {
  AssetCell,
  AssetLogo,
  AssetSymbol,
  AssetName,
  PriceCell,
  PerformanceCell,
  IndustryCell,
} from "./AllHoldingsModal.styles";

// Local formatters to avoid named export issues from utils
const formatCurrency = (value) => {
  if (isNaN(value)) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(value);
};

const formatPercent = (value) => {
  if (isNaN(value)) return "0.00%";
  return `${Number(value).toFixed(2)}%`;
};

export const columns = [
  {
    id: "asset",
    dataField: "asset",
    text: "Asset",
    props: {
      cell: ({ row }) => {
        const data = row.original;
        return (
          <AssetCell>
            <AssetLogo>
              <Avatar
                src={getStockCompanyIcon(data.asset)}
                name={data.asset}
                round={true}
                size={30}
              />
            </AssetLogo>
            <div>
              <AssetSymbol>{data.asset}</AssetSymbol>
              <AssetName>{data.company_name}</AssetName>
            </div>
          </AssetCell>
        );
      },
    },
  },
  {
    id: "share_price",
    dataField: "share_price",
    text: "Share Price",
    props: {
      cell: ({ getValue }) => (
        <PriceCell>{formatCurrency(getValue())}</PriceCell>
      ),
    },
  },
  {
    id: "performance",
    dataField: "performance_1y_percent",
    text: "Performance",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        const isPositive = value >= 0;
        return (
          <PerformanceCell>
            <div className={`performance-pill ${isPositive ? "gain" : "loss"}`}>
              {isPositive ? <ArrowUpProfitIcon /> : <ArrowDownLossIcon />}
              {formatPercent(value)}
            </div>
            <div className="performance-period">1 Year</div>
          </PerformanceCell>
        );
      },
    },
  },
  {
    id: "industry",
    dataField: "industry",
    text: "Industry",
    props: {
      cell: ({ getValue }) => (
        <IndustryCell>
          <img src={laptop} alt="Industry" />
          {getValue()}
        </IndustryCell>
      ),
    },
  },
];
